import { graphql } from '@/lib/query'

const SectionSeparatorFragment = graphql(/* GraphQL */ `
  fragment SectionSeparatorFragment on SectionSeparatorRecord @_unmask {
    _modelApiKey
    __typename
  }
`)

export default SectionSeparatorFragment
